import { Popover } from "antd";
import moment from "moment";
import React, { useContext, useState } from "react";
import TimeInput from "../../common/TimeInput";
import { convertToLocal } from "../utils/helpers";
import { TrackerContext } from "../utils/types";

const ROW_HEIGHT = 46;

export const LiveTimer: React.FC = () => {
  const { isTracking, liveTime, startTime, editCurrentSession } =
    useContext(TrackerContext);
  const [timerOpen, setTimerOpen] = useState(false);

  const handleAutoTimeChange = (value?: string) => {
    let parsed = moment(value, "HH:mm");
    const existing = moment(startTime);
    if (moment().isBefore(parsed)) parsed = parsed.subtract(1, "day");
    if (
      parsed.isValid() &&
      parsed.format("HH:mm") !== existing.format("HH:mm")
    ) {
      editCurrentSession(parsed.toISOString());
    }
  };

  const startTimePopoverContent = (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <span
        style={{
          color: "#999",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 1,
          textTransform: "uppercase",
        }}
      >
        Start time
      </span>
      <TimeInput
        style={{ width: 80, textAlign: "center", fontWeight: 600 }}
        valueProps={convertToLocal(startTime).format("HH:mm")}
        placeholder=""
        onBlur={(v) => {
          handleAutoTimeChange(v);
          setTimerOpen(false);
        }}
      />
      <span style={{ color: "#888", fontSize: 13 }}>
        {convertToLocal(startTime).isSame(moment(), "day")
          ? "Today"
          : convertToLocal(startTime).format("MMM D")}
      </span>
    </div>
  );

  return (
    <div
      style={{
        height: ROW_HEIGHT,
        display: "flex",
        alignItems: "center",
      }}
    >
      {isTracking ? (
        <Popover
          visible={timerOpen}
          onVisibleChange={(v: boolean) => setTimerOpen(v)}
          trigger="click"
          placement="bottomRight"
          content={startTimePopoverContent}
        >
          <div
            style={{
              cursor: "pointer",
              padding: "0 16px",
              color: "#137AE9",
              fontWeight: 700,
              fontSize: 20,
              letterSpacing: 1,
              userSelect: "none",
              minWidth: 110,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: ROW_HEIGHT,
            }}
          >
            {moment().hour(0).minute(0).second(liveTime).format("HH:mm:ss")}
          </div>
        </Popover>
      ) : (
        <span
          style={{
            color: "#aaa",
            fontWeight: 600,
            fontSize: 20,
            padding: "0 16px",
            minWidth: 110,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: ROW_HEIGHT,
          }}
        >
          00:00:00
        </span>
      )}
    </div>
  );
};
